import $ from 'jquery';
import 'jquery.transit';

export const elements = {
    call: '.js-BubbleBox-Call',
    holder: '.js-BubbleBox-Holder',
    box: '.js-BubbleBox-Box',
    remove: '.js-BubbleBox-Remove',
    input: '.comment-textfield .text-editor',
};

export const show = ($window, $call, $holder, $box) => {
    const boxWidth = $box.data('ui-bubblebox-width');
    const boxShift = $box.data('ui-bubblebox-shift');
    const boxPosition = $box.data('ui-bubblebox-position');
    const boxOffset = $box.data('ui-bubblebox-offset');
    if (!$box.hasClass('fn-visible')) {
        const boxShiftPx = `${boxShift}px`;
        const width = ($window.width() < boxWidth + 20) ? ($window.width() - 20) : `${boxWidth}px`;
        const windowWidth = $window.width();

        $box.css({ width });

        if (((windowWidth > 375) && (windowWidth < 800)) || (boxPosition === 'right')) {
            $box.addClass('right').css('right', boxShiftPx);
        } else {
            $box.addClass('left').css('left', boxShiftPx);
        }

        $box.addClass('fn-visible');
        $box.transit({ opacity: 1, top: `${boxOffset}px` });
    }
};

export const remove = ($box) => {
    if ($box.hasClass('fn-visible')) {
        $box.transit({ opacity: 0, top: 0 });
        setTimeout(() => { $box.removeClass('fn-visible'); }, 400);
    }
};

export default {
    init(params) {
        const { $window, $document } = params;
        const callClassName = elements.call.replace('.', '');

        $document.on('click', elements.call, (e) => {
            let $target = $(e.target);
            let continuePropagation = true;

            if ($target.is(elements.call) || $target.parents().hasClass(callClassName)) {
                $target = !$target.hasClass(callClassName) ?
                    $target.parents(elements.call) :
                    $target;

                const $holder = $target.parents(elements.holder);
                const $box = $holder.find(elements.box);

                const $activeCall = $(`${elements.call}.fn-active`);
                const $alreadyActive = $activeCall.parents(elements.holder).find(elements.box);

                remove($alreadyActive);

                if (!$target.hasClass('fn-active')) {
                    $target.addClass('fn-active');
                    show($window, $target, $holder, $box);
                } else {
                    $activeCall.removeClass('fn-active');
                    remove($box);
                }

                continuePropagation = false;
            } else if (!$target.parents(elements.holder).length && !$target.is(elements.holder)) {
                remove($(elements.box));
                $(elements.call).removeClass('fn-active');
                setTimeout(() => { $('.js-Comment-Action-Box').removeClass('fn-active'); }, 400);
                continuePropagation = false;
            }

            return continuePropagation;
        });

        $document.on('click', elements.remove, (e) => {
            const $target = $(e.target);
            const $box = $target.parents(elements.box);
            const $call = $box.prev(elements.call);

            remove($box);

            $call.removeClass('fn-active');

            return false;
        });

        $document.on('click', (event) => {
            const box = $(elements.box);
            const targetIsBubbleBox = !!box.is(event.target);
            const targetIsBubbleBoxChild = !!$(event.target)
              .parents(elements.box).length;
            const targetIsBubbleBoxCall = $(event.target)
              .hasClass(elements.call.substr(1))
              || $(elements.input).is(event.target) || $(elements.input).find('span').is(event.target);
            const $call = box.prev(elements.call);
            const shouldRemove = !targetIsBubbleBox
              && !targetIsBubbleBoxChild
              && box.hasClass('fn-visible')
              && !targetIsBubbleBoxCall;

            if (shouldRemove) {
              $call.removeClass('fn-active');
              remove(box);

              return;
            }
       });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/bubble-box.js